import { RemoveStorage, SetStorage } from "../../../Utils/Storage";

export const setCurrentPlanId = (state, action) => {
  RemoveStorage('optime_map_id');
  SetStorage('optime_map_id', action.planId);
  return { ...state, CurrentPlanId: action.planId };
}

export const clearState = (state, action, initialState) => {
  return { ...state, [action.state]: initialState[action.state] };
}